import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getAutomations, createAutomation, updateAutomation, deleteAutomation } from "api/bMarketingApi";

export function useMarketingAutomations(organisationId, type = null) {
  return useQuery({
    queryKey: ["automations", organisationId, type],
    queryFn: () => getAutomations(organisationId, type).then((res) => res.data),
    enabled: !!organisationId,
    refetchInterval: type === "whatsapp" ? 30_000 : false,
  });
}

export function useCreateAutomation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => createAutomation(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["automations"] });
    },
  });
}

export function useUpdateAutomation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ automationId, data }) => updateAutomation(automationId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["automations"] });
    },
  });
}

export function useDeleteAutomation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (automationId) => deleteAutomation(automationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["automations"] });
    },
  });
}
